





































































import Vue, { PropType } from 'vue'

import { getDocumento, Documento, Arquivo } from '../../../../store/livro-digital/documentos-repository'

import { Livro } from '../../../../store/livro-digital/livros-repository'

import ComentariosDialog from './comentarios.vue'
import { aprovacao_repository, StatusAprovacao } from '../../../../store/livro-digital/aprovacoes-respotiroy'

export type Data = {
    paginas: string[]
    pagina: number
    loading: boolean
    aprovado: boolean
    zoom: number
    prevZoom: number
    grabbing: boolean
    show_consideracoes: boolean
    startPos: {
        left: number
        top: number
        x: number
        y: number
    }
}

export default Vue.extend({
    components: {
        ComentariosDialog
    },
    props: {
        livro: {
            type: Object as PropType<Livro>,
            required: true
        },
        documento: {
            type: Object as PropType<Documento>,
            required: true
        },
        IdDocsprime: {
            type: Number,
            required: true,
        },
        codigo_condominio: {
            type: Number,
            required: true
        },
        reverse: {
            type: Boolean,
            default: false
        }
    },
    data(): Data {
        return {
            paginas: [],
            pagina: 0,
            loading: false,
            aprovado: false,
            zoom: 1,
            prevZoom: 1,
            grabbing: false,
            show_consideracoes: false,
            startPos: {
                x: 0,
                y: 0,
                left: 0,
                top: 0
            }
        }
    },
    computed: {
        relacao() {
            return this.$store.getters.relacao;
        },
        show_selo() {
            if (this.documento.tipoDocumento !== 'Capa') {
                return false
            }
            if (!this.aprovado) {
                return false
            }
            return true
        },
        imagem() {
            if (this.paginas.length <= this.pagina) {
                return null;
            }
            let pagina = this.pagina as number
            let paginas = this.paginas as string[]
            return paginas[pagina]
        },
        controle_acesso() {
            return this.$store.getters.controleAcesso;
        },
        show_aprovacao() {
            /* @ts-ignore */
            return this.controle_acesso.livroDigital?.aprovacao || false
        }
    },
    methods: {
        messagePopUp() {
            this.show_consideracoes = true
        },
        hideConsideracoes() {
            this.show_consideracoes = false
        },
        close() {
            this.$emit('close')
        },
        toggleMenu() {
            this.$emit('toggleMenu')
        },
        onMouseDown(evt: MouseEvent) {
            const img = evt.target as HTMLImageElement
            const parent = img.closest('.content') as HTMLDivElement;
            this.startPos.x = evt.clientX;
            this.startPos.y = evt.clientY;
            this.startPos.left = parent.scrollLeft
            this.startPos.top = parent.scrollTop
            this.grabbing = true
            evt.preventDefault();
            evt.stopPropagation();
        },
        onMouseUp(evt: MouseEvent) {

            this.grabbing = false
            evt.preventDefault();
            evt.stopPropagation();
        },
        onMouseMove(evt: MouseEvent) {
            if (!this.grabbing) {
                return;
            }
            const img = evt.target as HTMLImageElement
            const content = img.closest('.content') as HTMLDivElement;


            const delta_x = (this.startPos.x - evt.clientX)
            const delta_y = (this.startPos.y - evt.clientY)

            const scroll_width = content.scrollWidth - content.offsetWidth
            const scroll_height = content.scrollHeight - content.offsetHeight

            let scroll_x = this.startPos.left + delta_x;
            if (scroll_x < 0) {
                scroll_x = 0;
            }
            if (scroll_x > scroll_width) {
                scroll_x = scroll_width
            }

            let scroll_y = this.startPos.top + delta_y;
            if (scroll_y < 0) {
                scroll_y = 0;
            }
            if (scroll_y > scroll_height) {
                scroll_y = scroll_height
            }

            content.scrollLeft = Math.round(scroll_x)
            content.scrollTop = Math.round(scroll_y)

        },
        updateZoom(evt: Event) {
            const img = evt.target as HTMLImageElement
            const parent = img.closest('.content') as HTMLDivElement;
            const zoom_x = (parent.offsetWidth - 50) / img.width
            const zoom_y = (parent.offsetHeight - 50) / img.height
            this.zoom = Math.min(zoom_x, zoom_y)
            this.prevZoom = this.zoom

        },
        incrementZoom() {
            this.prevZoom = this.zoom
            this.zoom += 0.1;
            if (this.zoom > 5) {
                this.zoom = 5;
            }

            this.$nextTick(() => {
                this.centerOnZoom()
            })
        },
        centerOnZoom() {
            const content = this.$refs.content as HTMLDivElement
            if (content.scrollWidth > content.offsetWidth && this.prevZoom != this.zoom) {

                if (content.scrollLeft != 0) {
                    content.scrollLeft = content.scrollLeft * this.zoom / this.prevZoom
                } else {
                    content.scrollLeft = Math.round(content.scrollWidth / 2 - content.offsetWidth / 2)
                }
            }
        },
        decrementZoom() {
            this.prevZoom = this.zoom
            this.zoom -= 0.1;
            if (this.zoom < 0.1) {
                this.zoom = 0.1
            }

            this.$nextTick(() => {
                this.centerOnZoom()
            })
        },
        nextPage() {
            if (this.pagina < this.paginas.length - 1) {
                this.pagina++;
            } else {
                this.$emit('next')
            }
        },
        prevPage() {
            if (this.pagina > 0) {
                this.pagina--;
            } else {
                this.$emit('prev')
            }
        },
        async loadDocumento() {
            this.loading = true
            try {

                this.paginas = await getDocumento({ codigo_condominio: this.codigo_condominio, IdDocsprime: this.IdDocsprime })

            } catch (error) {
                console.error(error)
            } finally {
                this.loading = false
            }
        },
        async loadAprovacoes() {
            try {
                if (this.documento.tipoDocumento !== 'Capa') {
                    return false
                }
                const CodCondominio = this.codigo_condominio
                const Ano = this.livro.ano
                const Mes = this.livro.mes
                const aprovacoes = await aprovacao_repository.lista({
                    CodCondominio,
                    Ano,
                    Mes
                })
                const aprovacao = aprovacoes.find(aprovacao => aprovacao.Papel === 'Síndico')
                
                
                if (aprovacao && [StatusAprovacao.APROVADO, StatusAprovacao.APROVADO_COM_RESSALVA].includes(aprovacao.Status)) {
                    this.aprovado = true
                } else {
                    this.aprovado = false
                }
            } catch (error) {
                console.error(error)
            } finally {

            }
        },
        async print() {
            const win = window.open('about:blank', '_new');
            win?.document.open();
            win?.document.write(`
                <html>
                    <head>
                        <style>
                            html, body {
                                margin: 0;
                                padding: 0;
                                text-align: center;
                            }
                        </style>    
                    </head>
                    <body onload="window.print()" onafterprint="window.close()">
                        <img src="${this.imagem}" />
                    </body>
                </html>
            `.trim())
            win?.document.close();
        }
    },
    watch: {
        IdDocsprime: {
            immediate: true,
            async handler() {
                this.pagina = 0;
                this.loadAprovacoes()
                await this.loadDocumento()
                if (this.reverse) {
                    this.pagina = this.paginas.length - 1;
                }
            }
        }
    }
})

